import React from 'react';

import { DownOutlined, FilterOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import Dropdown from '..';
import styled from '@emotion/styled';
import { useLazyGetProductTagsQuery } from 'app/features/products/api';

const StyledLabel = styled.a`
  color: #3a4861;
`;
const DropdownProductTags = (props: {
  value?: Array<string | number> | string | number | null | undefined;
  onApply?: (
    values: Array<string | number> | string | number | null | undefined
  ) => void;
  onReset?: () => void;
}) => {
  const [fetch] = useLazyGetProductTagsQuery();
  const { value } = props;
  const [selectedValue, setSelectedValue] = React.useState<
    Array<string | number>
  >(['all']);

  const onApply = (values: Array<string | number>) => {
    setSelectedValue(values);
    if (props.onApply) {
      props.onApply(values);
    }
  };

  const onReset = () => {
    if (props.onReset) {
      props.onReset();
    }
  };

  const onFetch = async (
    pagination: {
      currentPage: number;
      pageSize: number;
    },
    search: any
  ) => {
    const params: any = {
      current: pagination.currentPage,
      pageSize: pagination.pageSize
    };
    if (search?.keywords) {
      params['keywords'] = search.keywords;
    }
    const response = await fetch(params).unwrap();

    return response.data?.map((item) => {
      return {
        value: item.id,
        label: item.name
      };
    });
  };
  React.useEffect(() => {
    setSelectedValue(value as any);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <Dropdown.FilterDropdown
      lazy
      lazyProps={{
        fetch: onFetch as any
      }}
      renderLabel={() => {
        return (
          <Button type="text">
            <StyledLabel type="link">
              <Space size={8}>
                <FilterOutlined />
                {selectedValue?.includes('all')
                  ? 'All Customer Tags'
                  : `Customer Tags(${selectedValue?.length ?? ''})`}
                <DownOutlined />
              </Space>
            </StyledLabel>
          </Button>
        );
      }}
      value={selectedValue}
      onApply={onApply}
      onReset={onReset}
      options={[{ value: 'all', label: 'All Customer Tags' }]}
    ></Dropdown.FilterDropdown>
  );
};

export default DropdownProductTags;
